export const PUBLISH_TYPE = {
  IMMEDIATELY: 'immediately',
  SCHEDULED: 'scheduled',
} as const;

/** 添付ファイルの最大アップロード件数 */
export const MAX_ATTACHMENT_FILES = 10;
